const IS_REFACTOR_STAGING = process.env.VUE_APP_MODE === 'staging'
const IS_REFACTOR_PROD = process.env.VUE_APP_MODE === 'refactor'
const IS_PRODUCTION = process.env.VUE_APP_MODE === 'production'

const SESSIONS = {
  IS_PRODUCTION,
  IS_REFACTOR_PROD,
  IS_REFACTOR_STAGING,
}

export default SESSIONS
